import GUI from "../../../containers/gui";
import React from "react";
import PropTypes from "prop-types";
import {withRouter} from 'react-router-dom';
import qs from "qs";
import {setPlayer} from "../../..";
import { setPhone } from "../../reducers/teach";
import {setProjectId} from "../../../reducers/project-state";
import {connect} from "react-redux";
import {post} from '../../api/api';
import StepRecorder from "../../guide/step-recorder";
import StepEditor from '../step-editor';
import CartoonEditor from '../../guide/avatar-action';
import BrowserBox from '../../../components/webgl-modal/chromeBrowser';
import event, { EVENTS } from "../../lib/event";
import { headNavBack } from "../../lib/utils";
//StepRecorder.startRecordStep(step => console.log(JSON.stringify(step)))


class WrappedGui extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleUpdateProjectThumbnail.bind(this);
        this.handBack.bind(this);
        this.query = qs.parse(props.location.search, {ignoreQueryPrefix: true});
        if(this.query.type){
            props.setPlayer(true); //确保为Player模式
        }else{
            props.setPlayer(false)
        }
        this.state={isExpend:true}
        const ua = navigator.userAgent.toLocaleLowerCase();
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(ua)) {
            props.setPhone(true);
        } else {
            props.setPhone(false);
        }
    }

    handleUpdateProjectThumbnail(projectId, data) {
        post('oss/thumb/' + projectId + '.png', {quiet:true})(data);
    }

    handleProjectTelemetryEvent(e, metadata) {
        event.emit(e, metadata);
    }

    handBack(){
        headNavBack(this.props.history)
    }

    handleExpend(){
        this.setState({
            isExpend:!this.state.isExpend
        })
    }



    render() {
        const backpackHost = null;
        const {isExpend} = this.state
        return (<GUI
            canEditTitle
            backpackVisible
            showComingSoon
            backpackHost={backpackHost}
            //zhiao begin
            canSave={true}
            autoSave={false}
            canCreateCopy={true}
            canShare={true}
            enableCommunity={true}
            canChangeLanguage={false}
            assetHost={window.config.assetHost}
            projectHost={window.config.projectHost}
            assetGetUrl={window.config.staticURL + '/assets'}
            basePath='/'
            onClickLogo={() => {this.handBack()}}
            onUpdateProjectThumbnail={this.handleUpdateProjectThumbnail}
            onProjectTelemetryEvent={this.handleProjectTelemetryEvent}
            isExpend={isExpend}  //聊天框是否展开
            onClickExpend={()=>this.handleExpend()}
            //showComingSoon={false}
            {...this.props}
            //zhiao end
        />);
    }
}

WrappedGui.propTypes={
    setPlayer: PropTypes.func,
    setPhone: PropTypes.func
}

const mapDispatchToProps = dispatch => ({
    setProjectId: projectId => {
        dispatch(setProjectId(projectId));
    },
    setPlayer: isPlayerOnly => dispatch(setPlayer(isPlayerOnly)),
    setPhone: isPhone => dispatch(setPhone(isPhone)),
});
export default connect(null, mapDispatchToProps)(withRouter(WrappedGui));

